// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_moment_dist_index_js-node_modules_leaflet-defaulticon-compatib-1c7d79":"081a80864ab4d929c1dd","node_modules_moment_locale_sync_recursive_-src_views_PhotosTab_vue":"fd5ad19946eb337fd210"}[chunkId] + "";
};